export default {
  title: 'AMES ENGLISH',
  copyright: 'AMES LEARNING © 2019',
  domain_url_ames: 'https://toeic.ames.edu.vn',
  domain_url_ebm: 'https://ebm.softech.cloud'
};
